/**
 * Activity Log Types
 * Frontend types matching backend ActivityLog entity
 */

export enum ActivityType {
  // Workspace activities
  WORKSPACE_CREATED = 'workspace_created',
  WORKSPACE_UPDATED = 'workspace_updated',
  WORKSPACE_DELETED = 'workspace_deleted',
  WORKSPACE_ARCHIVED = 'workspace_archived',
  WORKSPACE_SETTINGS_CHANGED = 'workspace_settings_changed',

  // Member activities
  MEMBER_ADDED = 'member_added',
  MEMBER_REMOVED = 'member_removed',
  MEMBER_ROLE_CHANGED = 'member_role_changed',
  MEMBER_LEFT = 'member_left',

  // Join request activities
  JOIN_REQUEST_SUBMITTED = 'join_request_submitted',
  JOIN_REQUEST_APPROVED = 'join_request_approved',
  JOIN_REQUEST_REJECTED = 'join_request_rejected',

  // Board activities
  BOARD_CREATED = 'board_created',
  BOARD_UPDATED = 'board_updated',
  BOARD_DELETED = 'board_deleted',
  BOARD_ARCHIVED = 'board_archived',

  // Folder activities
  FOLDER_CREATED = 'folder_created',
  FOLDER_UPDATED = 'folder_updated',
  FOLDER_DELETED = 'folder_deleted',
  FOLDER_MOVED = 'folder_moved',

  // Task activities
  TASK_CREATED = 'task_created',
  TASK_UPDATED = 'task_updated',
  TASK_DELETED = 'task_deleted',
  TASK_STATUS_CHANGED = 'task_status_changed',
  TASK_PRIORITY_CHANGED = 'task_priority_changed',
  TASK_ASSIGNED = 'task_assigned',
  TASK_UNASSIGNED = 'task_unassigned',
  TASK_MOVED = 'task_moved',
  TASK_COMPLETED = 'task_completed',
  TASK_REOPENED = 'task_reopened',
  TASK_DUE_DATE_CHANGED = 'task_due_date_changed',
  COMMENT_ADDED = 'comment_added',
  ATTACHMENT_ADDED = 'attachment_added',
  ATTACHMENT_DELETED = 'attachment_deleted',

  // Sprint & Epic activities
  SPRINT_STARTED = 'sprint_started',
  SPRINT_COMPLETED = 'sprint_completed',
  TASK_LINKED_TO_EPIC = 'task_linked_to_epic',
}

export enum EntityType {
  WORKSPACE = 'workspace',
  BOARD = 'board',
  TASK = 'task',
  FOLDER = 'folder',
  MEMBER = 'member',
  JOIN_REQUEST = 'join_request',
  SPRINT = 'sprint',
  EPIC = 'epic',
}

export interface ActivityLog {
  id: string;
  userId: string | null;
  workspaceId: string | null;
  activityType: ActivityType;
  entityType: EntityType;
  entityId: string;
  entityName: string | null;
  metadata: any;
  description: string | null;
  createdAt: string;
  updatedAt: string;

  // Relations (populated by backend)
  user?: {
    id: string;
    name: string;
    email: string;
  };
  workspace?: {
    id: string;
    name: string;
  };
}

export interface ActivityFeedResponse {
  activities: ActivityLog[];
  total: number;
}

export interface ActivityFeedParams {
  limit?: number;
  offset?: number;
  hours?: number;
}
